import NewApiService from "@/utils/new.api.service";

export default {
  updateDiscount(context, params) {
    context.commit("loading", true);
    return new Promise(resolve => {
      NewApiService.put(`order-row/${params.rowId}/discount`,
        params.discount
      ).then(({ data }) => {
        context.commit("loading", false);
        resolve(data);
      });
    });
  },
  removeDiscount(context, row) {
    context.commit("loading", true);
    return new Promise(resolve => {
      NewApiService.delete(`order-row/${row.id}/discount`
      ).then(({ data }) => {
        context.commit("loading", false);
        resolve(data);
      });
    });
  },
  getDiscountList(context) {
    context.commit("loading", true);
    return new Promise(resolve => {
      NewApiService.get("order-row/discount").then(({ data }) => {
        context.commit("loading", false);
        resolve(data);
      });
    });
  }
};
